import zwitCore from "./config/http";
const BASE_URL = process.env.NODE_ENV === "development" ? "/apis" : "";
export default {
  // 征稿函列表
  getLetterList(data) {
    return zwitCore.HTTP.postJsonData(
      BASE_URL + "/zw-knowledge/solicitation/page",
      data
    );
  },
  getMyPage(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-knowledge/solicitation/list",
      data
    );
  },
  getMyPages(data) {
    return zwitCore.HTTP.json(
      BASE_URL + "/zw-knowledge/solicitation/myPage",
      data
    );
  },
  getDetail(data) {
    return zwitCore.HTTP.get(
      BASE_URL + "/zw-knowledge/solicitation/detail",
      data,
      false
    );
  },
};
